export default __webpack_public_path__ + "cc907c04634c45ce11c2f560706b6515.otf";